import axios from "axios";
import { useEffect, useState } from "react";
import { baseurl, baseurImage } from "../../Baseurl";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom"
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import axiosInstance from "../../api/axiosInstance";
export default function Labs() {
  const navigate = useNavigate();
  const [hodalopen, setHodalopen] = useState(false);
  const [formData, setFormData] = useState({});
  const [logoFile, setLogoFile] = useState(null);
  const [data, getData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [labServices, setLabServices] = useState([]);
  const [selectedServiceIds, setSelectedServiceIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);


  const filteredData = data.filter((lab) => {
    const searchTermLower = searchTerm.toLowerCase();
    return (
      (lab.lab_name && lab.lab_name.toLowerCase().includes(searchTermLower)) ||
      (lab.email && lab.email.toLowerCase().includes(searchTermLower)) ||
      (lab.phone_number && lab.phone_number.toLowerCase().includes(searchTermLower)) ||
      (lab.address && lab.address.toLowerCase().includes(searchTermLower)) ||
      (lab.speciality && lab.speciality.toLowerCase().includes(searchTermLower))
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const openmodal = () => {
    setHodalopen(true);
    setFormData({ serviceIds: [] });
    setEditMode(false);
    setLogoFile(null);
    setErrors({});
  };
  const handlecloseVital = () => {
    setHodalopen(false);
    setLogoFile(null);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone_number" || name === "phone") {
      // Allow only digits and cap to 10 characters
      const digitsOnly = (value || "").replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({ ...prev, phone_number: digitsOnly }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogoChange = (e) => {
    setLogoFile(e.target.files[0] || null);
  };
  const validateForm = () => {
    const newErrors = {};

    // Required fields validation
    if (!formData.lab_name || !formData.lab_name.trim()) {
      newErrors.lab_name = "Lab Name is required";
    }
    if (!formData.email || !formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!formData.phone_number || !formData.phone_number.trim()) {
      newErrors.phone_number = "Phone number is required";
    } else if (!/^\d{8}$/.test(formData.phone_number)) {
      newErrors.phone_number = "Enter a valid 8-digit phone number";
    }
    if (!formData.address || !formData.address.trim()) {
      newErrors.address = "Address is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleapisubmit = async () => {
    // Validate form first
    if (!validateForm()) {
      return;
    }

    try {
      const submitData = new FormData();

      // Add all form fields, including empty ones
      const requiredFields = ['lab_name', 'email', 'address', 'speciality', 'notes'];
      requiredFields.forEach(field => {
        submitData.append(field, formData[field] || '');
      });

      // Add services_id as array from serviceIds
      if (formData.serviceIds && Array.isArray(formData.serviceIds)) {
        submitData.append('services_id', JSON.stringify(formData.serviceIds));
      } else {
        submitData.append('services_id', JSON.stringify([]));
      }

      // Backend expects 'phone' field name
      submitData.append('phone', formData.phone_number || '');

      // Add logo file if selected
      if (logoFile) {
        submitData.append('image', logoFile);
      }

      if (editMode) {
        const response = await axiosInstance.put(`updateLabById/${formData.id}`, submitData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (response.data.success === true) {
          Swal.fire("Success", "Lab updated successfully", "success");
          getDataset();
          handlecloseVital();
        } else {
          Swal.fire("Error", "Failed to update lab", "error");
        }
      } else {
        const response = await axiosInstance.post(`addLabs`, submitData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (response.data.success === true) {
          Swal.fire("Success", "Lab added successfully", "success");
          getDataset();
          handlecloseVital();
        } else {
          Swal.fire("Error", "Something went wrong", "error");
        }
      }
    } catch (error) {
      const err = error.response?.data?.message || "Unexpected error";
      Swal.fire("Error", err, "error");
    }
  };
  useEffect(() => {
    getDataset();

    axiosInstance.get(`getAllLabServices`).then(res => {
      if (res.data.success && Array.isArray(res.data.data)) {
        setLabServices(res.data.data);
      }
    });
  }, []);
  const getDataset = async () => {
    try {
      const response = await axiosInstance.get(`getAllLabs`);
      if (response.data.success === true) {
        getData(response.data.data);
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch labs", "error");
    }
  };
  const handleStatusChange = async (id, status) => {
    try {
      const response = await axiosInstance.put(`changeLabStatus/${id}`, {
        status: status,
      });
      if (response.data.success === true) {
        Swal.fire("Success", "Status Updated", "success");
        getDataset();
      } else {
        Swal.fire("Error", "Failed to update status", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };
  const handleEdit = (item) => {
    // Parse services_id if it exists and is a string
    let serviceIds = [];
    if (item.services_id) {
      try {
        serviceIds = typeof item.services_id === 'string'
          ? JSON.parse(item.services_id)
          : Array.isArray(item.services_id)
            ? item.services_id
            : [];
      } catch (e) {
        console.error('Error parsing services_id:', e);
        serviceIds = [];
      }
    }

    setFormData({
      ...item,
      serviceIds: serviceIds
    });
    setEditMode(true);
    setHodalopen(true);
  };
  const handleView = (item) => {
    navigate(`/Admin/ViewLabDetails/${item.id}`);
  };
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the lab!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });
    if (confirm.isConfirmed) {
      try {
        const response = await axiosInstance.delete(`deleteLabById/${id}`);
        if (response.data.success === true) {
          Swal.fire("Deleted!", "Lab has been deleted.", "success");
          getDataset();
        } else {
          Swal.fire("Error", "Failed to delete lab", "error");
        }
      } catch (error) {
        Swal.fire("Error", "Something went wrong", "error");
      }
    }
  };
  const getLabServiceNames = (lab) => {
    let serviceIds = [];

    if (lab.services_id) {
      try {
        serviceIds =
          typeof lab.services_id === "string"
            ? JSON.parse(lab.services_id)
            : Array.isArray(lab.services_id)
              ? lab.services_id
              : [];
      } catch (e) {
        console.error("Error parsing services_id for lab:", e);
        serviceIds = [];
      }
    }

    if (!serviceIds.length || !Array.isArray(labServices)) {
      return "";
    }

    const matchedServices = labServices.filter((service) =>
      serviceIds.includes(service.id)
    );

    return matchedServices
      .map(
        (service) =>
          service.serviceName ||
          service.service ||
          service.name ||
          ""
      )
      .filter(Boolean)
      .join(", ");
  };

  const truncateText = (text, maxLength = 50) => {
    if (!text) return "-";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const [expandedServiceRows, setExpandedServiceRows] = useState({});

  const toggleServiceExpansion = (labId) => {
    setExpandedServiceRows(prev => ({
      ...prev,
      [labId]: !prev[labId]
    }));
  };

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="row">
          <div className="col-12">
            <div className="col-12 searchParent">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span
                  style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                  onClick={() => navigate(-1)}
                  title="Back"
                >
                  &larr;
                </span>
                All Labs
              </h5>
            </div>
            <div className="card table-card">
              <div className="card-header d-flex align-items-center" style={{ gap: '1rem' }}>
                <div className="flex-grow-1" style={{ maxWidth: 320 }}>
                  <div style={{ position: 'relative' }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by Lab Name..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{ paddingLeft: '35px' }}
                    />
                    <span
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '10px',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'none',
                        color: '#888'
                      }}
                    >
                      <i className="ti ti-search f-16"></i>
                    </span>
                  </div>
                </div>
                <div className="ms-auto d-flex align-items-center" style={{ gap: '8px' }}>
                  <button className="export">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      style={{ marginTop: 4, marginRight: 4, marginLeft: 4 }}
                    >
                      <path
                        d="M9 17.75c-.1 0-.19-.02-.29-.06a.74.74 0 0 1-.46-.69v-6c0-.41.34-.75.75-.75s.75.34.75.75v4.19l.72-.72c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-2 2c-.14.14-.34.22-.53.22Z"
                        fill="currentColor"
                      />
                      <path
                        d="M9 17.751c-.19 0-.38-.07-.53-.22l-2-2a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z"
                        fill="currentColor"
                      />
                      <path
                        d="M15 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 5.43-2.32 7.75-7.75 7.75Z"
                        fill="currentColor"
                      />
                      <path
                        d="M22 10.748h-4c-3.42 0-4.75-1.33-4.75-4.75v-4c0-.3.18-.58.46-.69.28-.12.6-.05.82.16l8 8a.751.751 0 0 1-.53 1.28Zm-7.25-6.94v2.19c0 2.58.67 3.25 3.25 3.25h2.19l-5.44-5.44Z"
                        fill="currentColor"
                      />
                    </svg>
                  </button>
                  <button className="btn btn-primary px-4" onClick={openmodal}>
                    Add Lab
                  </button>
                </div>
              </div>
              <div className="card-body pt-3">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Logo</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Address</th>
                        <th>Services</th>
                        <th>Requests</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {item.image ? (
                                <img
                                  src={`${baseurImage}${item.image}`}
                                  alt="Lab Logo"
                                  style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px' }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                              ) : null}
                              <div
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  backgroundColor: '#f0f0f0',
                                  borderRadius: '4px',
                                  display: item.image ? 'none' : 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                              >
                                <i className="ti ti-building f-16 text-muted"></i>
                              </div>
                            </td>
                            <td>{item.lab_name}</td>
                            <td>{item.email}</td>
                            <td>{item.phone_number}</td>
                            <td>{item.address}</td>
                            <td className="text-wrap" style={{ maxWidth: "260px" }}>
                              {(() => {
                                const serviceNames = getLabServiceNames(item);
                                if (!serviceNames || serviceNames === "-") return "-";

                                const isExpanded = expandedServiceRows[item.id];
                                const displayText = isExpanded ? serviceNames : truncateText(serviceNames, 50);

                                return (
                                  <div>
                                    <span>{displayText}</span>
                                    {serviceNames.length > 50 && (
                                      <button
                                        onClick={() => toggleServiceExpansion(item.id)}
                                        className="btn btn-link btn-sm p-0 ms-1"
                                        style={{ fontSize: "0.85em", textDecoration: "none" }}
                                      >
                                        {isExpanded ? "Show less" : "Show more"}
                                      </button>
                                    )}
                                  </div>
                                );
                              })()}
                            </td>
                            <td>
                              <span className="badge bg-primary">{item.assigned_count || 0}</span>
                            </td>
                            <td>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch-info"
                                  type="checkbox"
                                  id={`toggle-${item.id}`}
                                  checked={item.is_active === 1}
                                  onChange={(e) =>
                                    handleStatusChange(item.id, e.target.checked ? 1 : 0)
                                  }
                                />
                                <label
                                  className="form-check-label ms-2"
                                  htmlFor={`toggle-${item.id}`}
                                >
                                  {item.is_active ? "Active" : "Inactive"}
                                </label>
                              </div>
                            </td>
                            <td>
                              <div
                                onClick={() => handleView(item)}
                                style={{ cursor: "pointer" }}
                                className="avtar avtar-xs btn-link-secondary viewIcon"
                              >
                                <i className="ti ti-eye f-20" />
                                <span>View</span>
                              </div>
                              <div
                                onClick={() => handleEdit(item)}
                                style={{ cursor: "pointer" }}
                                className="avtar avtar-xs btn-link-secondary editIcon"
                              >
                                <i className="ti ti-edit f-20" />
                                <span>Edit</span>
                              </div>
                              <div
                                onClick={() => handleDelete(item.id)}
                                style={{ cursor: "pointer" }}
                                className="avtar avtar-xs btn-link-secondary deleteIcon"
                              >
                                <i className="ti ti-trash f-20" />
                                <span>Delete</span>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No labs found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {totalPages > 1 && (
                  <div className="d-flex justify-content-end mt-3">
                    <PaginationComponent
                      currentPage={currentPage}
                      totalPages={totalPages}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                )}
                {hodalopen && (
                  <div
                    className="modal fade show"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
                  >
                    <div className="modal-dialog modal-lg">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">{editMode ? "Edit Lab" : "Add Lab"}</h5>
                          <button type="button" className="btn-close" onClick={handlecloseVital}></button>
                        </div>
                        <div className="container mt-4">
                          <div className="row">
                            {[
                              { label: "Lab Name", name: "lab_name", type: "text" },
                              { label: "Email", name: "email", type: "email" },
                              { label: "Phone", name: "phone_number", type: "text" },
                              { label: "Address", name: "address", type: "text" },
                              { label: "Speciality", name: "speciality", type: "text" },
                              { label: "Notes", name: "notes", type: "text" },
                            ].map((field, idx) => (
                              <div className="col-md-6 mb-3" key={idx}>
                                <label className="form-label">{field.label}:</label>
                                <input
                                  type={field.type}
                                  name={field.name}
                                  value={formData[field.name] || ""}
                                  onChange={handleChange}
                                  className={`form-control ${errors[field.name] ? 'is-invalid' : ''}`}
                                  {...(field.name === 'phone_number' ? { maxLength: 8, inputMode: 'numeric', pattern: "\\d*" } : {})}
                                />
                                {errors[field.name] && (
                                  <div className="invalid-feedback">
                                    {errors[field.name]}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label className="form-label">Lab Logo:</label>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={handleLogoChange}
                                className="form-control"
                              />
                              {logoFile && (
                                <small className="text-muted"></small>
                              )}
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <label className="form-label">Service Name(s)</label>
                            <Autocomplete
                              multiple
                              id="lab-services-autocomplete"
                              options={labServices}
                              getOptionLabel={(option) =>
                                option.serviceName || option.service || option.name || "Unknown Service"
                              }
                              value={
                                (formData.serviceIds || [])
                                  .map((id) => labServices.find((service) => service.id === id))
                                  .filter(Boolean)
                              }
                              onChange={(e, newValue) => {
                                const hasSelectAll = newValue.some(
                                  (option) => option && option.isSelectAll
                                );

                                if (hasSelectAll) {
                                  const isAllSelected =
                                    formData.serviceIds &&
                                    labServices.length > 0 &&
                                    formData.serviceIds.length === labServices.length;

                                  const nextIds = isAllSelected
                                    ? []
                                    : labServices.map((service) => service.id);

                                  setFormData((prev) => ({
                                    ...prev,
                                    serviceIds: nextIds,
                                  }));
                                } else {
                                  const filtered = newValue.filter(
                                    (option) => !option.isSelectAll
                                  );
                                  setFormData((prev) => ({
                                    ...prev,
                                    serviceIds: filtered.map((service) => service.id),
                                  }));
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Select Lab Services"
                                  placeholder="Search services..."
                                />
                              )}
                              filterOptions={(options, { inputValue }) => {
                                const searchLower = inputValue.toLowerCase();
                                const filtered = options.filter((option) => {
                                  const serviceName = option.serviceName || option.service || option.name || '';
                                  const category = option.category || '';
                                  return (
                                    serviceName.toLowerCase().includes(searchLower) ||
                                    category.toLowerCase().includes(searchLower)
                                  );
                                });

                                if (!inputValue) {
                                  return [
                                    {
                                      id: "__all__",
                                      serviceName: "Select / Deselect All",
                                      isSelectAll: true,
                                    },
                                    ...filtered,
                                  ];
                                }

                                return filtered;
                              }}
                              noOptionsText="No services found"
                              loadingText="Loading services..."
                              disabled={labServices.length === 0}
                              renderOption={(props, option) => {
                                if (option.isSelectAll) {
                                  return (
                                    <li {...props}>
                                      <strong>Select / Deselect All</strong>
                                    </li>
                                  );
                                }

                                const serviceName = option.serviceName || option.service || option.name || 'Unknown Service';
                                const category = option.category || '';
                                const price = option.price || 0;

                                return (
                                  <li {...props}>
                                    <div>
                                      <strong>{serviceName}</strong>
                                      {category && (
                                        <small className="text-muted d-block">
                                          Category: {category}
                                        </small>
                                      )}
                                      {price > 0 && (
                                        <small className="text-success d-block">
                                          Price: {price} BHD
                                        </small>
                                      )}
                                    </div>
                                  </li>
                                );
                              }}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                    key={option.id}
                                    label={
                                      (option.serviceName || option.service || option.name || 'Unknown Service') +
                                      (option.category ? ` (${option.category})` : '')
                                    }
                                    {...getTagProps({ index })}
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))
                              }
                            />
                          </div>

                          <div className="d-flex justify-content-center">
                            <button type="submit" onClick={handleapisubmit} className="btn btn-primary my-3">
                              {editMode ? "Update Lab" : "Add Lab"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function PaginationComponent({ currentPage, totalPages, setCurrentPage }) {
  return (
    <div className="d-flex align-items-center gap-3">
      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        disabled={currentPage === 1}
      >
        &lt;&lt;
      </button>
      <span>
        {currentPage} / {totalPages}
      </span>
      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
        disabled={currentPage === totalPages}
      >
        &gt;&gt;
      </button>
    </div>
  );
}
